// S5, screen A: a session the reader may not see.
// No `@/` import, so `node --test` can load this file directly.
//
// GET /sessions/{id} answers 403. To a member of the session's horse its body is
//   { message, can_request, horse: {id, name}, start_at, access_request: null | {id, status: 'pending'|'refused'} }
// and never says whose session it is. Anyone else gets a bare 403 ({message}): nothing to ask.

import { isAccessDenied } from './API/fetcher-core.js'
import { STATUS_PENDING, requestState } from './invitations.js'

export { isAccessDenied }

// What screen A shows, or null for a bare 403 (the reader may ask for nothing).
// { status: 'none'|'pending'|'refused', requestId, canRequest, horse: {id, name}, startAt }
export const sessionAccessState = (body) => {
    if (!body || typeof body !== 'object' || !body.horse || typeof body.horse !== 'object') return null

    const { status, requestId } = requestState(body.access_request)

    return {
        status,
        requestId,
        // One pending request per person and session: no second one while it waits.
        canRequest: status !== STATUS_PENDING && body.can_request !== false,
        horse: { id: body.horse.id ?? null, name: body.horse.name ?? '' },
        startAt: body.start_at ?? null,
    }
}

// From the access-denied error of GET /sessions/{id}: the state of screen A, or null.
export const sessionAccessStateFromError = (error) =>
    isAccessDenied(error) ? sessionAccessState(error.response.data) : null
